module.exports = __webpack_public_path__ + "55536c8e9e9a532651e3cf374f290ea3.woff2";